import React from 'react';

interface ChatHeaderProps {
  isOnline: boolean;
  onMinimize: () => void;
  onClose: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({
  isOnline,
  onMinimize,
  onClose
}) => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white p-4 flex items-center justify-between">
      <div className="flex items-center space-x-3">
        {/* AI头像 */}
        <div className="w-8 h-8 rounded-full bg-white bg-opacity-20 flex items-center justify-center">
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
        </div>

        <div>
          <h3 className="font-medium text-sm">智能客服"大白"</h3>
          <div className="flex items-center space-x-1">
            <div
              className={`w-2 h-2 rounded-full ${
                isOnline ? 'bg-green-400 animate-pulse' : 'bg-gray-400'
              }`}
            />
            <span className="text-xs opacity-90">
              {isOnline ? '在线' : '连接中...'}
            </span>
          </div>
        </div>
      </div>

      {/* 操作按钮 */}
      <div className="flex items-center space-x-1">
        {/* 最小化按钮 */}
        <button
          onClick={onMinimize}
          className="w-6 h-6 rounded hover:bg-white hover:bg-opacity-20 flex items-center justify-center transition-colors"
          title="最小化"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
          </svg>
        </button>

        {/* 关闭按钮 */}
        <button
          onClick={onClose}
          className="w-6 h-6 rounded hover:bg-white hover:bg-opacity-20 flex items-center justify-center transition-colors"
          title="关闭"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};